import React from 'react'
import styles from '@bt-react/styles'

interface Props {
  id: string
  value: string
  name: string
  onChange: any
  dataBdd?: string
  label?: string
  checked?: boolean
  disabled?: boolean
}

const RadioButton = (props: Props) => {

  const bdd = typeof props.dataBdd !== 'undefined' ? props.dataBdd : 'radio-button'

  return <div className={styles[ 'radio-container' ]} data-bdd={bdd}>
    <input
      data-bdd='radio-button-input'
      id={props.id}
      name={props.name}
      type="radio"
      checked={props.checked}
      onChange={props.onChange}
      value={props.value}
      disabled={props.disabled}
    />
    <label
      data-bdd='radio-button-label'
      className={styles['radio-label']}
      htmlFor={props.id}
    >
      <span className={styles[`radio`]}>
        {props.label}
      </span>
    </label>
  </div>

}

export default RadioButton
